import { definedMap } from "@glideapps/ts-necessities";
import { asString } from "common/components/component-helpers";
import { Corners } from "common/components/image-types";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { isEmptyOrUndefinedish } from "common/Support";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { TagOverlayView } from "../ui/views/tag-overlay/tag-overlay-view";

export const TagOverlayMaterialRenderer: GlideFunctionalRenderer = p => {
    const { getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[textPV, cornersPV]] = useForceValueProducers(getValueProducers, force, ctx);
    if (textPV === LOADING || cornersPV === LOADING) {
        return null;
    }

    const text = definedMap(textPV, asString);
    const corners = definedMap(cornersPV, asString) as Corners;

    if (isEmptyOrUndefinedish(text)) return null;

    return (
        <TagOverlayView data-test="app-tag-overlay" round={corners === Corners.Rounded}>
            {text}
        </TagOverlayView>
    );
};
